import type { Allocation } from '@talos/kyoko';
import { useMemo } from 'react';
import { useSubAccounts } from '../providers';
import { useFeatureFlag } from './useFeatureFlag';

/**
 * Returns sub-account allocations for restricted trading mode.
 * When enableAccountSegregationWithRestrictedTrading is off, returns -1 (no sub-account restriction).
 * When on, returns tradable sub-accounts as Allocation[] for use with usePermittedTradableMarketAccountsSet.
 */
export function useSubAccountAllocationsForRestrictedTrading(): Allocation[] | -1 {
  const { enableAccountSegregationWithRestrictedTrading } = useFeatureFlag();
  const { tradableSubAccounts } = useSubAccounts();

  return useMemo<Allocation[] | -1>(() => {
    if (!enableAccountSegregationWithRestrictedTrading) {
      return -1;
    }
    return (
      tradableSubAccounts?.map(sa => ({
        subAccount: sa.Name,
        value: '',
      })) ?? []
    );
  }, [tradableSubAccounts, enableAccountSegregationWithRestrictedTrading]);
}
